import { IndexableDataStructureWrapper, BuildRequestBodyParams } from "../../components/MenuTreeView/MenuTreeView.types";
import { useOrganizationsDetails } from "../../services/menu/menu.service";
import { Organization } from "../../services/menu/menu.types";

const getDataStructure = (activateOrExtract: string): IndexableDataStructureWrapper => {
  return {
    "org": {
      fetchChildren: useOrganizationsDetails,
      idKey: 'org',
      showCheckboxes: true,
      buildLabel: (params: BuildRequestBodyParams) => params.row.label,
      buildRequestBody: (params: BuildRequestBodyParams) => {
        return { orgNo: params.row.id, activateOrExtract: activateOrExtract};
      },
      buildParentArray: (params: Organization) => {
        return [{ level: 0, id: params.id }];
      },
      getIndexByType: () => { return 0}
    },
    "territory": {
      idKey: 'territory',
      showCheckboxes: true,
      buildLabel: (params: BuildRequestBodyParams) => params.row.label,
      buildParentArray: (params: Organization) => {
        const parents = [];
        if (params.parents) {
          parents.push({level: 0, id: params.parents['org']});
        }
        parents.push({level: 1, id: params.id});
        return parents;
      },
      getIndexByType: () => { return 1}
    },
    "region": {
      idKey: 'region',
      showCheckboxes: true,
      buildLabel: (params: BuildRequestBodyParams) => params.row.label,
      buildParentArray: (params: Organization) => {
        const parents = [];
        if (params.parents) {
          parents.push({level: 0, id: params.parents['org']});
          parents.push({level: 1, id: params.parents['territory']});
        }
        parents.push({level: 2, id: params.id});
        return parents;
      },
      getIndexByType: () => { return 2}
    },
    "market": {
      idKey: 'market',
      showCheckboxes: true,
      buildLabel: (params: BuildRequestBodyParams) => params.row.label,
      buildParentArray: (params: Organization) => {
        const parents = [];
        if (params.parents) {
          parents.push({level: 0, id: params.parents['org']});
          parents.push({level: 1, id: params.parents['territory']});
          parents.push({level: 2, id: params.parents['region'] || ''});
        }
        parents.push({level: 3, id: params.id});
        return parents;
      },
      getIndexByType: () => { return 3}
    },
    "area": {
      idKey: 'area',
      showCheckboxes: true,
      buildLabel: (params: BuildRequestBodyParams) => params.row.label,
      buildParentArray: (params: Organization) => {
        const parents = [];
        if (params.parents) {
          parents.push({level: 0, id: params.parents['org']});
          parents.push({level: 1, id: params.parents['territory']});
          parents.push({level: 2, id: params.parents['region'] || ''});
          parents.push({level: 3, id: params.parents['market'] || ''});
        }
        parents.push({level: 4, id: params.id});
        return parents;
      },
      getIndexByType: () => { return 4}
    },
    "store": {
      idKey: 'store',
      showCheckboxes: true,
      buildLabel: (params: BuildRequestBodyParams) => params.row.label,
      buildParentArray: (params: Organization) => {
        const parents = [];
        if (params.parents) {
          parents.push({level: 0, id: params.parents['org']});
          parents.push({level: 1, id: params.parents['territory']});
          parents.push({level: 2, id: params.parents['region'] || ''});
          parents.push({level: 3, id: params.parents['market'] || ''});
          parents.push({level: 4, id: params.parents['area']});
        }
        parents.push({level: 5, id: params.id});
        return parents;
      },
      getIndexByType: () => { return 5}
    },
    "menu": {
      to: () => '',
      idKey: 'menuNo',
      showCheckboxes: true,
      buildLabel: (params: BuildRequestBodyParams) => {
        return `${params.row.label}`;
      },
      buildParentArray: (params: Organization) => {
        const parents = [];
        if (params.parents) {
          parents.push({level: 0, id: params.parents['org']});
          parents.push({level: 1, id: params.parents['territory']});
          parents.push({level: 2, id: params.parents['region'] || ''});
          parents.push({level: 3, id: params.parents['market'] || ''});
          parents.push({level: 4, id: params.parents['area']});
          parents.push({level: 5, id: params.parents['store']});
        }
        parents.push({level: 6, id: params.id});
        return parents;
      },
      getIndexByType: () => { return 6}
    }
  }
}

export default getDataStructure;